import { http } from "@/lib/http";
export const QUIZ_EXPORT_URL = `${
  import.meta.env.VITE_API_BASE_URL
}/api/quiz/export`;
export function fetchAllQuizzes() {
  return http.get("/api/quiz/getAllQuiz").then((res) => res.data);
}
export function deleteQuiz(id) {
  return http.delete(`/api/quiz/delete/${id}`).then((res) => res.data);
}
export function fetchQuizAnalytics(id) {
  return http.get(`/api/quiz/analytics/${id}`).then((res) => res.data);
}
export function saveQuiz(quiz) {
  return http.post("/api/quiz/batchadd", quiz).then((res) => res.data);
}
/**
 * Dedicated single-quiz update (ported from Vue2 main branch feat/sr-23784
 * "inline edit dialog for Quiz Management"). Unlike /batchadd, this rejects
 * changes to `code` server-side.
 */
export function updateQuiz(id, payload) {
  return http.post(`/api/quiz/update/${id}`, payload).then((res) => res.data);
}
